import styled from '@emotion/styled'
import { useAtomValue } from 'jotai'
import { FC } from 'react'
import { FlexColumn } from 'src/components/flex-containers'
import { WidgetCardEmpty } from 'src/v2/components/widget-card/empty'
import { Shapes } from 'src/components/theme'
import { AssessedValues } from 'src/v2/views/owner-reveal/insights/portfolio-summary/property-type-breakdown/assessed-values'
import { BuildingAreaCoverage } from 'src/v2/views/owner-reveal/insights/portfolio-summary/property-type-breakdown/building-area-coverage'
import { Overview } from 'src/v2/views/owner-reveal/insights/portfolio-summary/property-type-breakdown/overview'
import * as atoms from 'src/v2/state/owner-reveal/portfolio-summary'

const Row = styled.div`
  display: flex;
  gap: ${Shapes.spacing[8]}px;
  padding-inline: ${Shapes.spacing[6]}px;
  flex-direction: column;

  @media (min-width: 1025px) {
    flex-direction: row;
  }
`

export const PropertyTypeBreakdownContent: FC = () => {
  const overview = useAtomValue(atoms.propertyTypesOverview)
  const propertyTypesAssesedValue = useAtomValue(atoms.propertyTypesAssesedValue)
  const propertyTypesSqFt = useAtomValue(atoms.propertyTypesSqFt)

  if (!overview && !propertyTypesAssesedValue && !propertyTypesSqFt) {
    return (
      <WidgetCardEmpty message="It looks like we don't have data for this Owner yet. We're constantly gathering new data, so keep an eye out for updates." />
    )
  }

  return (
    <FlexColumn gap={Shapes.spacing[6]}>
      <Overview />
      <Row>
        <AssessedValues />
        <BuildingAreaCoverage />
      </Row>
    </FlexColumn>
  )
}
